import { useIsLaptop } from '@synoptic/ui-kit/responsive/hooks.ts';
import { FC } from 'react';
import { UnauthenticatedActionDrawer } from './unauthenticated-action-drawer.tsx';
import { UnauthenticatedActionModal } from './unauthenticated-action-modal.tsx';

export type UnauthenticatedActionPromptProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export const UnauthenticatedActionPrompt: FC<
  UnauthenticatedActionPromptProps
> = ({ open, onOpenChange }) => {
  const isLaptop = useIsLaptop();

  return isLaptop ? (
    <UnauthenticatedActionModal open={open} onOpenChange={onOpenChange} />
  ) : (
    <UnauthenticatedActionDrawer open={open} onOpenChange={onOpenChange} />
  );
};
